class SplittingShift{
    constructor(data){
        this.offset = data.offset;
        this.weeks = data.weeks;
        this.ignoreAOnPublicHoliday = parseInt(data.ignoreAOnPublicHoliday);
        this.intervals = data.intervals;
        this.minNrOfBlockIntervals = (parseInt(data.mindestblock)/60 * (this.offset/24));
        this.minDistanceIntervals = (parseInt(data.minDistance)/60 * (this.offset/24));
        this.maxDistanceIntervals = (parseInt(data.maxDistance)/60 * (this.offset/24));
        this.wishWindow = new Array(data.weeks);
        this.weekdays = ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"];
        this.lastSplittingShiftIndex = data.lastSplittingShiftIndex;
        this.currentSplittingShiftIndex = data.currentSplittingShiftIndex;
        this.splittingShiftFound = data.splittingShiftFound;
        this.errorText = new Array(data.weeks);
        this.wishBreak = data.wishBreak;
    }

    getSplittingShiftFound(){
        return this.splittingShiftFound;
    }

    getError(week, day){
        return this.errorText [week][day];
    }

    checkSplitting(){
        for(let week = 1; week <= this.wishWindow.length; week++){
            this.wishWindow[week-1] = new WishWeek(this.offset, week, this.ignoreAOnPublicHoliday);
            this.wishWindow[week-1].setDays();
        }
        let errorText = this._isSplittingOkay();
        return errorText;
    }

    _isSplittingOkay(){
        for(let nrOfWeek = 0; nrOfWeek < this.wishWindow.length ; nrOfWeek++) {
            this.errorText [nrOfWeek] =  new Array (7);
            for(let day = 0; day < 7; day++) {
                this.errorText [nrOfWeek][day] = this._isSplittingShift(nrOfWeek, day);
            }
        }
    }

    _isCurrentSplittingShiftTheLast(){
        return this.lastSplittingShiftIndex === this.currentSplittingShiftIndex;
    }

    _isSplittingShift(nrOfWeek, day){
        //if((!this.ignoreAOnPublicHoliday && !this.wishWindow[nrOfWeek].isPublicHoliday(day)) && !this.wishWindow[nrOfWeek].isPublicHoliday(day)){
        let numberSegments = this.wishWindow[nrOfWeek].getNumberOfASegments(day);
        if(numberSegments == 2 && !this.splittingShiftFound[nrOfWeek][day]){
            if(this.wishWindow[nrOfWeek].getNumberOfAIntervalls(day) == this.intervals) {
                if (this.wishWindow[nrOfWeek].getNumberOfIntervalsFirstSegment(day, this.wishBreak) >= this.minNrOfBlockIntervals && this.wishWindow[nrOfWeek].getNumberOfIntervalsLastSegment(day, this.wishBreak) >= this.minNrOfBlockIntervals) {
                    let numberOfIntervallsBetweenA = this.wishWindow[nrOfWeek].getNumberOfIntervalsBetweenTwoASegments(day);
                    if (numberOfIntervallsBetweenA < this.minDistanceIntervals) {
                        return "<b>Woche " + (nrOfWeek + 1) + ": " + this.weekdays[day] + "</b></br>Mindestabstand zwischen den Schichtelementen wird nicht eingehalten. <br>";
                    } else if (numberOfIntervallsBetweenA > this.maxDistanceIntervals) {
                        return "<b>Woche " + (nrOfWeek + 1) + ": " + this.weekdays[day] + "</b></br>Maximalabstand zwischen den Schichtelementen wird nicht eingehalten. <br>";
                    } else {
                        this.splittingShiftFound[nrOfWeek][day] = true;
                    }
                } else {
                    return "<b>Woche " + (nrOfWeek + 1) + ": " + this.weekdays[day] + "</b></br>Mindestlänge der Schichtelemente wird nicht eingehalten. <br>";
                }
            } else if (this._isCurrentSplittingShiftTheLast()) {
                return "<b>Woche " + (nrOfWeek + 1) + ": " + this.weekdays[day] + "</b></br>Die Anzahl der eingegebenen Intervalle passt nicht zu einer Splittingschicht. <br>";
            }
        } else if(numberSegments > 2 && this._isCurrentSplittingShiftTheLast()){
            return "<b>Woche " + (nrOfWeek + 1) + ": " + this.weekdays[day] + "</b></br>Es wurden zu viele Splittingsegmente eingegeben. <br>";
        }
        return "";
    }
}